/**
 * Cross-tab propagation of "milestone chat sent by me".
 *
 * The backend's `milestone-new-chat` websocket event skips the author, so the
 * author's other open tabs (e.g. the board chat list) never learn about their
 * own new message. The sending tab broadcasts the milestone id, and every other
 * tab re-emits it onto the in-tab event bus as `milestone-chat-sent`, using the
 * same payload shape as `milestone-new-chat` so handlers can be shared.
 *
 * Counterpart of `milestoneChatSeenChannel.js`. Kept as its own channel because
 * it needs a distinct event name: reusing `milestone-new-chat` would make
 * `MilestoneDetailsPage` count the user's own message as unread.
 *
 * TODO: In a cleanup task, merge this and `milestoneChatSeenChannel.js` into a
 * single milestone chat cross-tab module with one init call.
 */
import { createCrossTabChannel } from 'source/lib/crossTabChannel.js';

const channel = createCrossTabChannel('milestone-chat-sent', 'milestone-chat-sent');

/**
 * Start listening for cross-tab "milestone chat sent" broadcasts. Called once
 * at app startup so a tab can receive broadcasts even if it never sends a
 * milestone chat itself.
 */
export function initMilestoneChatSentChannel() {
    channel.init();
}

/**
 * Notify other tabs that the current user sent a chat in the given milestone.
 *
 * @param {number | string} milestoneId - The milestone the chat was sent in.
 */
export function broadcastMilestoneChatSent(milestoneId) {
    if (milestoneId == null) return;
    channel.broadcast({ milestone_id: Number(milestoneId) });
}
